/* ==========================================================
   A pleno pulmón · Club NasoStrips
   1 bolsa de tiras pagada = 1 ficha (pack de 30 = 1, 90 = 3, 150 = 5).
   Con NSClub.goal fichas se desbloquea una sorpresa (producto oculto de 0 €,
   SKU NS-REGALO-CLUB) que se añade sola al carrito si hay sesión iniciada.
   window.NSClub lo calcula Liquid (snippets/ns-club-state) con los pedidos
   pagados del cliente. Este archivo: sorpresa automática y aviso interno del
   pedido, filas del carrito y de la ficha, celebración en azul («¡Enhorabuena!
   Recompensa desbloqueada»), animación de tarjetas y la vista previa
   ?club_demo= (solo en temas sin publicar; ?club_demo=off la quita).
   ========================================================== */
(() => {
  const C = window.NSClub;
  if (!C || window.NSClubAPI) return;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const ATTRIBUTE = 'A pleno pulmón';
  const esc = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const fichas = n => `${n} ${n === 1 ? 'ficha' : 'fichas'}`;
  const store = kind => ({
    get: key => { try { return window[kind].getItem(key); } catch (e) { return null; } },
    set: (key, value) => { try { if (value === null) window[kind].removeItem(key); else window[kind].setItem(key, value); } catch (e) {} }
  });
  const session = store('sessionStorage');
  const local = store('localStorage');
  const reduced = Boolean(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  /* ---------- Vista previa (solo temas sin publicar) ---------- */
  const DEMO = {guest:{logged:false}, start:{}, sample:{samples:1}, progress1:{tokens:1}, progress2:{tokens:2}, progress3:{tokens:3}, almost:{tokens:C.goal - 1}, ready:{tokens:C.goal - 1}, owed:{tokens:C.goal}, again:{tokens:C.goal, redeemed:1}, done:{tokens:C.goal, redeemed:1}};
  const derive = raw => {
    const goal = C.goal, logged = raw.logged !== false;
    const tokens = raw.tokens || 0, samples = raw.samples || 0, redeemed = raw.redeemed || 0;
    let earned = Math.floor(tokens / goal);
    if (!C.repeat) earned = Math.min(earned, 1);
    const owed = Math.max(earned - redeemed, 0);
    let fill = tokens % goal, done = false;
    if (!C.repeat && tokens >= goal) { fill = goal; done = owed === 0; }
    const state = !logged ? 'guest' : owed > 0 ? 'owed' : done ? 'done' : fill > 0 ? 'progress' : earned > 0 ? 'again' : samples > 0 ? 'sample' : 'start';
    return {logged, tokens, samples, redeemed, earned, owed, fill, done, state, shown: state === 'owed' || state === 'done' ? goal : fill, firstName: logged ? 'Ana' : '', customerId: 0};
  };
  if (C.demoAllowed) {
    const asked = new URLSearchParams(location.search).get('club_demo');
    if (asked === 'off') session.set('nsair-demo', null);
    else if (asked && DEMO[asked]) session.set('nsair-demo', asked);
    const key = session.get('nsair-demo');
    if (key && DEMO[key]) Object.assign(C, derive(DEMO[key]), {demo: key});
  }

  /* ---------- Fichas del carrito (mismo cálculo que Liquid) ---------- */
  const lines = cart => (cart && cart.items) ? cart.items : [];
  const isGift = item => Boolean(C.giftVariantId) && item.variant_id === C.giftVariantId;
  const isProtect = item => Boolean(window.NSProtect) && item.variant_id === window.NSProtect.variantId;
  const bagsPer = title => {
    const units = parseInt(String(title || '').trim().split(/\s+/)[0], 10) || 0;
    return units >= 30 ? Math.floor(units / 30) : 1;
  };
  const bagsOf = item => (isGift(item) || isProtect(item) || !(item.final_line_price > 0)) ? 0 : bagsPer(item.variant_title) * item.quantity;
  const cartBags = cart => lines(cart).reduce((total, item) => total + bagsOf(item), 0);
  const paidLines = cart => lines(cart).filter(item => bagsOf(item) > 0);
  const giftLine = cart => lines(cart).find(isGift) || null;
  const earnedWith = bags => {
    const earned = Math.floor((C.tokens + bags) / C.goal);
    return C.repeat ? earned : Math.min(earned, 1);
  };
  /* Sorpresas que deben ir en este carrito: las debidas + las que desbloquea. Nunca sin un pack pagado. */
  const giftsWanted = cart => {
    const bags = cartBags(cart);
    return (C.logged && C.giftVariantId && bags > 0) ? Math.max(earnedWith(bags) - C.redeemed, 0) : 0;
  };
  const newUnlocks = cart => Math.max(giftsWanted(cart) - C.owed, 0);

  const request = async (path, body) => {
    const init = body ? {method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'}, body:JSON.stringify(body)} : {headers:{Accept:'application/json'}};
    const response = await fetch(root + path, {credentials:'same-origin', ...init});
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || 'No hemos podido actualizar el carrito.');
    return data;
  };

  /* ---------- Celebración: pulmones llenos, azul y «¡Enhorabuena!» ---------- */
  const confetti = dialog => {
    const box = dialog.querySelector('.nsair-cele__confetti');
    if (!box || reduced) return;
    const colors = ['#a9dbff', '#eef8ff', '#d8e9ae', '#5fa8ee', '#ffffff'];
    for (let i = 0; i < 36; i++) {
      const dot = document.createElement('i');
      const size = 5 + Math.random() * 9;
      dot.style.cssText = `left:${(Math.random() * 100).toFixed(1)}%;width:${size.toFixed(1)}px;height:${size.toFixed(1)}px;background:${colors[i % colors.length]};animation-delay:${(Math.random() * 0.7).toFixed(2)}s;animation-duration:${(1.9 + Math.random() * 1.5).toFixed(2)}s;--dx:${((Math.random() - 0.5) * 140).toFixed(0)}px`;
      box.appendChild(dot);
    }
  };
  const openCelebration = context => {
    const template = document.getElementById('nsair-celebrate-tpl');
    if (!template || document.querySelector('.nsair-cele[open]')) return null;
    const dialog = template.content.firstElementChild.cloneNode(true);
    const card = dialog.querySelector('.nsair-cele__card');
    const text = dialog.querySelector('[data-nsair-cele-text]');
    const cta = dialog.querySelector('[data-nsair-cele-cta]');
    const prize = `<strong>sorpresa valorada en ${esc(C.giftValue)}</strong>`;
    if (context === 'cart') {
      text.innerHTML = `Has completado tus ${C.goal} fichas con este pedido. Te hemos añadido una ${prize}: va gratis en tu caja.`;
      cta.textContent = 'Ver mi pedido';
    } else {
      text.innerHTML = `Has completado tus ${C.goal} fichas. Tu ${prize} se añadirá gratis a tu próximo pedido.`;
      cta.textContent = 'Genial';
    }
    card.style.setProperty('--p', String(Math.min((C.goal - 1) / C.goal, 0.8)));
    document.body.appendChild(dialog);
    dialog.addEventListener('close', () => dialog.remove());
    dialog.addEventListener('click', event => {
      if (event.target === dialog || event.target.closest('[data-nsair-cele-close]')) dialog.close();
    });
    try { dialog.showModal(); } catch (e) { dialog.setAttribute('open', ''); }
    const run = (delay, step) => (reduced ? step() : setTimeout(step, delay));
    run(30, () => dialog.classList.add('is-open'));
    run(180, () => card.style.setProperty('--p', '1'));
    run(1250, () => { dialog.classList.add('is-blue', 'is-burst'); confetti(dialog); });
    run(1650, () => dialog.classList.add('is-revealed'));
    return dialog;
  };
  /* Una sola vez por recompensa (en vista previa, una vez por sesión). */
  const celebrate = (context, index) => {
    const memory = C.demo ? session : local;
    const key = `nsair-cele:${C.demo ? `demo-${C.demo}` : C.customerId}:${index}`;
    if (memory.get(key)) return;
    memory.set(key, '1');
    openCelebration(context);
  };

  /* ---------- Sorpresa automática + aviso interno del pedido ---------- */
  /* Devuelve true si ha cambiado el carrito (quien llama debe releer cart.js). */
  const sync = async (cart, options = {}) => {
    if (!C.giftVariantId) return false;
    let current = cart || await request('cart.js');
    const want = giftsWanted(current), unlocked = newUnlocks(current), bags = cartBags(current), line = giftLine(current);
    let changed = false;
    if (want && !line) {
      await request('cart/add.js', {items:[{id:C.giftVariantId, quantity:want, properties:{
        'Valorada en': C.giftValue,
        _nsair: `fichas ${C.tokens} + ${bags} en el carrito · sorpresas entregadas ${C.redeemed} · cliente ${C.customerId || 0}${C.demo ? ' · PRUEBA' : ''}`
      }}]});
      changed = true;
    } else if (line && line.quantity !== want) {
      await request('cart/change.js', {id:line.key, quantity:want});
      changed = true;
    }
    if (changed) current = await request('cart.js');
    const note = want ? `INCLUIR ${want === 1 ? 'SORPRESA' : `${want} SORPRESAS`} · valorada en ${C.giftValue}${want > 1 ? ' cada una' : ''}` : '';
    if (((current.attributes || {})[ATTRIBUTE] || '') !== note) {
      await request('cart/update.js', {attributes:{[ATTRIBUTE]: note}});
      changed = true;
    }
    const panelOpen = Boolean(document.getElementById('ns-cart-panel') && document.getElementById('ns-cart-panel').open);
    if (unlocked && (options.celebrate ?? panelOpen)) celebrate('cart', earnedWith(bags));
    return changed;
  };

  const LUNG = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 3v6.5M12 9.5c-.8 1.1-1.9 1.9-3.2 2.4M12 9.5c.8 1.1 1.9 1.9 3.2 2.4M10 6.2C7.2 5.9 4.2 9.4 3.6 14.6c-.3 2.9.6 5.1 2.8 5.4 1.9.3 3.6-.8 3.6-2.6V7.4M14 6.2c2.8-.3 5.8 3.2 6.4 8.4.3 2.9-.6 5.1-2.8 5.4-1.9.3-3.6-.8-3.6-2.6V7.4"/></svg>';
  const GIFT_ART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="l" d="M10.6 6.3C7.6 5.8 4.3 9.3 3.6 14.6c-.4 3 .6 5.3 2.9 5.6 2 .3 3.9-.9 3.9-2.8V7.6c0-.6.1-1 .2-1.3zM13.4 6.3c3-.5 6.3 3 7 8.3.4 3-.6 5.3-2.9 5.6-2 .3-3.9-.9-3.9-2.8V7.6c0-.6-.1-1-.2-1.3z"/><path class="t" d="M12 2.8v7.2M12 10c-.7 1-1.6 1.7-2.8 2.2M12 10c.7 1 1.6 1.7 2.8 2.2"/><path class="b" d="M7.2 12.6c-.9 1-1.4 2.2-1.6 3.6M16.8 12.6c.9 1 1.4 2.2 1.6 3.6"/></svg>';
  const loginHref = () => C.loginPath + encodeURIComponent(location.pathname);

  /* Mismos textos que snippets/ns-club-cart-row.liquid: si cambias uno, cambia el otro. */
  const cartRow = cart => {
    const goal = C.goal, bags = cartBags(cart), want = giftsWanted(cart), value = esc(C.giftValue);
    /* Con sesión se saluda por el nombre: es la señal de «sí, estás dentro» justo antes de pagar. */
    const who = C.logged && C.firstName ? `${esc(C.firstName)}, ` : '';
    const how = `<a href="${esc(C.pageUrl)}">Cómo funciona</a>`;
    const login = `<a href="${esc(loginHref())}">Inicia sesión</a>`;
    const bar = (on, next) => `<div class="nsair-cart__bar" style="--goal:${goal}" aria-hidden="true">${Array.from({length: goal}, (_, k) => `<i class="${k < on ? 'is-on' : k < on + next ? 'is-next' : ''}"></i>`).join('')}</div>`;
    let cls = '', title, text, segments = '';
    if (!C.logged) {
      if (bags >= goal) { title = 'Este pedido desbloquea una sorpresa'; text = `${login} antes de pagar y te la llevas: valorada en ${value}.`; }
      else { title = `Este pedido suma ${fichas(bags)}`; text = `${login} para guardarlas: con ${goal} fichas, sorpresa valorada en ${value}.`; }
    } else if (C.state === 'done') {
      title = 'Ya disfrutaste tu sorpresa'; text = 'Gracias por respirar con nosotros.';
    } else if (want > 0) {
      cls = ' is-unlocked';
      title = want > 1 ? `¡${want} recompensas desbloqueadas!` : '¡Recompensa desbloqueada!';
      text = want > 1 ? `${want} sorpresas añadidas, valoradas en ${value} cada una.` : `Sorpresa añadida, valorada en ${value}.`;
      segments = bar(goal, 0);
    } else {
      const after = Math.min(C.fill + bags, goal), left = goal - after;
      title = `${who}${who ? 'e' : 'E'}ste pedido suma ${fichas(bags)}`;
      text = `Tienes ${C.fill} de ${goal} y tendrás ${after}: ${left === 1 ? 'te faltará 1 para la sorpresa.' : left <= 0 ? 'completas tus fichas.' : `te faltarán ${left} para la sorpresa.`}`;
      segments = bar(C.fill, Math.min(bags, goal - C.fill));
    }
    return `<div class="nsair-cart${cls}" data-nsair-cart><span class="nsair-cart__icon" aria-hidden="true">${LUNG}</span><div><strong>${title}</strong><span>${text} ${how}</span></div>${segments}</div>`;
  };

  /* Mismo marcado que snippets/ns-club-gift-line.liquid. */
  const giftLineHTML = item => {
    const qty = (item && item.quantity) || 1;
    return `<article class="nsair-gline" aria-label="Sorpresa añadida, valorada en ${esc(C.giftValue)}"><div class="nsair-gline__art" aria-hidden="true">${GIFT_ART}</div><div><span class="nsair-gline__tag">Sorpresa · A pleno pulmón</span><strong class="nsair-gline__title">Sorpresa añadida${qty > 1 ? ` ×${qty}` : ''}</strong><div class="nsair-gline__row"><p class="nsair-gline__sub">Valorada en ${esc(C.giftValue)}${qty > 1 ? ' cada una' : ''}</p><span class="nsair-gline__price">Gratis</span></div></div></article>`;
  };

  /* ---------- Fila de la ficha: cambia con el pack elegido ---------- */
  const selectedBags = () => {
    const pack = document.querySelector('.uafp__pack-input:checked');
    if (!pack) return 1;
    const units = parseInt(String(pack.dataset.label || '').replace(/\D+/g, ' ').trim().split(' ')[0], 10) || 30;
    const quantityOutput = document.getElementById('uafp-quantity');
    const quantity = parseInt(quantityOutput ? quantityOutput.textContent : '1', 10) || 1;
    return (units >= 30 ? Math.floor(units / 30) : 1) * quantity;
  };
  const paintRow = () => {
    const rows = document.querySelectorAll('[data-nsair-row]');
    if (!rows.length) return;
    const bags = selectedBags(), goal = C.goal, value = esc(C.giftValue);
    let title, text, unlocked = false;
    if (C.state === 'done') {
      title = 'Club A pleno pulmón'; text = 'Ya disfrutaste tu sorpresa. Gracias.';
    } else if (!C.logged) {
      unlocked = bags >= goal;
      title = unlocked ? '¡Este pack desbloquea una sorpresa!' : `Este pack suma ${fichas(bags)}`;
      text = unlocked ? `Valorada en ${value}. Inicia sesión antes de pagar.` : `Con ${goal} fichas, sorpresa valorada en ${value}.`;
    } else if (C.owed > 0) {
      unlocked = true; title = 'Tu sorpresa va en este pedido'; text = `Valorada en ${value} · gratis.`;
    } else if (earnedWith(bags) - C.redeemed > 0) {
      unlocked = true; title = '¡Con este pack desbloqueas tu sorpresa!'; text = `Valorada en ${value} · se añade sola a tu pedido.`;
    } else {
      const after = Math.min(C.fill + bags, goal), left = goal - after;
      title = `Con este pack tendrás ${after} de ${goal} fichas`;
      text = `Ahora tienes ${C.fill}. ${left === 1 ? 'Te faltará 1 para la sorpresa.' : `Te faltarán ${left} para la sorpresa.`}`;
    }
    rows.forEach(row => {
      const titleEl = row.querySelector('[data-nsair-row-title]'), textEl = row.querySelector('[data-nsair-row-text]');
      if (titleEl) titleEl.textContent = title;
      if (textEl) textEl.innerHTML = `${text} <em>Ver cómo</em>`;
      row.classList.toggle('is-unlocked', unlocked);
    });
  };

  /* ---------- Tarjetas ---------- */
  const STAGES = ['Toma aire', 'Primera bocanada', 'Coges ritmo', 'Respiras hondo', 'Casi a pleno pulmón', 'A pleno pulmón'];
  const stageName = n => C.goal === 5 ? STAGES[Math.min(n, 5)] : n >= C.goal ? 'A pleno pulmón' : n === 0 ? 'Toma aire' : `${n} de ${C.goal}`;
  const hintFor = left => left <= 1 ? 'Tu próxima bolsa desbloquea la sorpresa.' : left <= 3 ? 'Un pack de 90 tiras (3 bolsas) la desbloquea.' : 'Un pack de 150 tiras (5 bolsas) la desbloquea de una vez.';
  const paintCard = (card, s, shown, blue = s.state === 'owed' || s.state === 'done') => {
    card.dataset.state = s.state;
    card.style.setProperty('--p', (shown / C.goal).toFixed(3));
    card.classList.toggle('is-full', shown >= C.goal);
    card.classList.toggle('is-blue', blue);
    card.querySelectorAll('[data-when]').forEach(el => { el.hidden = !el.dataset.when.split(' ').includes(s.state); });
    card.querySelectorAll('.nsair__stamp').forEach((li, i) => li.classList.toggle('is-on', i < shown));
    const stamps = card.querySelector('.nsair__stamps');
    if (stamps) stamps.setAttribute('aria-label', `Fichas: ${shown} de ${C.goal}`);
    card.querySelectorAll('[data-nsair-shown]').forEach(el => { el.textContent = shown; });
    card.querySelectorAll('[data-nsair-fill]').forEach(el => { el.textContent = s.fill; });
    card.querySelectorAll('[data-nsair-hint]').forEach(el => { el.textContent = hintFor(C.goal - s.fill); });
    card.querySelectorAll('[data-nsair-stage]').forEach(el => { el.textContent = stageName(shown); });
    card.querySelectorAll('[data-nsair-name]').forEach(el => { el.textContent = s.firstName ? `, ${s.firstName}` : ''; });
  };

  /* Sin sesión no hay fichas que enseñar: la tarjeta muestra en bucle cómo se llenan y se ponen azules. */
  const looping = new WeakSet();
  const guestLoop = card => {
    if (reduced || looping.has(card)) return;
    looping.add(card);
    let n = 0;
    const step = () => {
      if (!card.isConnected) return;
      n = n >= C.goal ? 0 : n + 1;
      paintCard(card, C, n, n >= C.goal);
      setTimeout(step, n >= C.goal ? 2800 : n === 0 ? 1000 : 1100);
    };
    setTimeout(step, 900);
  };
  const startCard = card => {
    card.classList.add('is-in');
    if (C.state === 'guest') guestLoop(card);
  };
  const initCards = () => {
    document.querySelectorAll('[data-nsair-card]').forEach(card => {
      if (card.dataset.nsairReady) return;
      card.dataset.nsairReady = 'true';
      if (C.demo) paintCard(card, C, C.shown);
      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          observer.disconnect();
          startCard(card);
        }, {threshold: 0.3});
        observer.observe(card);
      } else {
        startCard(card);
      }
    });
    document.querySelectorAll('[data-nsair-login]').forEach(link => { link.href = loginHref(); });
    paintRow();
  };

  /* ---------- Página del carrito (el lateral usa la API desde ns-cart-panel.js) ---------- */
  const cartPage = async () => {
    try {
      const pending = session.get('nsair-cele-pending');
      if (pending) { session.set('nsair-cele-pending', null); celebrate('cart', Number(pending)); }
      let cart = await request('cart.js');
      const unlocked = newUnlocks(cart), index = earnedWith(cartBags(cart));
      if (await sync(cart, {celebrate: false})) {
        const last = Number(session.get('nsair-reload') || 0);
        if (Date.now() - last > 8000) {
          if (unlocked) session.set('nsair-cele-pending', String(index));
          session.set('nsair-reload', String(Date.now()));
          location.reload();
          return;
        }
        cart = await request('cart.js');
      }
      if (unlocked && !pending) celebrate('cart', index);
      if (C.demo) document.querySelectorAll('#ns-premium-cart [data-nsair-cart]').forEach(el => { el.outerHTML = cartRow(cart); });
    } catch (e) { /* el club nunca bloquea el carrito */ }
  };

  /* ---------- Chip de sesión: quién eres y cuántas fichas llevas ---------- */
  /* Liquid ya lo pinta con el estado real; esto lo mantiene al día en la
     vista previa ?club_demo= y tras un cambio de sección en el editor. */
  const nextText = () => {
    const left = C.goal - C.shown;
    if (C.state === 'owed') return `Recompensa desbloqueada: tu sorpresa valorada en ${C.giftValue} va gratis en tu próximo pedido.`;
    if (C.state === 'done') return 'Ya disfrutaste tu sorpresa. Gracias por respirar con nosotros.';
    return left === 1 ? `Te falta 1 bolsa para tu sorpresa valorada en ${C.giftValue}.` : `Te faltan ${left} bolsas para tu sorpresa valorada en ${C.giftValue}.`;
  };
  const paintPills = () => {
    document.querySelectorAll('[data-nsair-pill-guest]').forEach(el => { el.hidden = C.logged; });
    document.querySelectorAll('[data-nsair-pill-user]').forEach(pill => {
      pill.hidden = !C.logged;
      if (!C.logged) return;
      pill.dataset.state = C.state;
      pill.style.setProperty('--p', (C.shown / C.goal).toFixed(3));
      pill.classList.toggle('is-blue', C.state === 'owed' || C.state === 'done');
      pill.querySelectorAll('[data-nsair-pill-shown]').forEach(el => { el.textContent = C.shown; });
      pill.querySelectorAll('.nsair-pill__bar > i').forEach((bar, i) => bar.classList.toggle('is-on', i < C.shown));
      if (C.firstName) {
        pill.querySelectorAll('[data-nsair-pill-name]').forEach(el => { el.textContent = C.firstName; });
        pill.querySelectorAll('[data-nsair-pill-initial]').forEach(el => { el.textContent = C.firstName.slice(0, 1).toUpperCase(); });
      }
      pill.querySelectorAll('[data-nsair-pill-next]').forEach(el => { el.textContent = nextText(); });
      const label = pill.querySelector('summary');
      if (label) label.setAttribute('aria-label', `Tu cuenta. Tienes ${C.shown} de ${C.goal} fichas de A pleno pulmón.`);
    });
  };
  const closePills = () => document.querySelectorAll('details[data-nsair-pill][open]').forEach(pill => { pill.open = false; });
  document.addEventListener('click', event => {
    if (!event.target.closest('details[data-nsair-pill]')) closePills();
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closePills(); });

  window.NSClubAPI = {state: C, sync, cartRow, giftLineHTML, giftLine, isGift, paidLines, cartBags, giftsWanted, paintCard, startCard, paintPills, celebrate: openCelebration};
  initCards();
  paintPills();
  document.addEventListener('shopify:section:load', initCards);
  document.addEventListener('change', event => { if (event.target.closest && event.target.closest('.uafp__pack-input')) paintRow(); });
  document.addEventListener('click', event => { if (event.target.closest && event.target.closest('[data-uaf-qty]')) setTimeout(paintRow, 0); });
  if (document.getElementById('ns-premium-cart')) cartPage();
  else if (C.state === 'owed') setTimeout(() => celebrate('owed', C.earned), 1400);
})();
